import { Navigate } from '../../components/Routing';

export const Home = () => <Navigate to="/projects" replace />;
